






































































// vue
import {
    computed,
    defineComponent,
    onMounted,
    ref,
} from '@vue/composition-api';

// services
import { useService } from '@/vue3/api/services';

// models
import { Tags } from '@/vue3/api/models';

// primevue
import Listbox from 'primevue/listbox';
import ProgressSpinner from 'primevue/progressspinner';
import Button from 'primevue/button';
import MultiSelect from 'primevue/multiselect';
import { useNotify } from '@/vue3/hooks/notifyHook';
import InputText from 'primevue/inputtext';

export default defineComponent({
    components: {
        Listbox,
        ProgressSpinner,
        Button,
        MultiSelect,
        InputText,
    },
    props: {
        geoRecord: {
            type: Object,
            default: () => {},
        },
        handleGeoRecordPropertyUpdate: {
            type: Function,
            default: () => {},
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        isMobile: {
            type: Boolean,
            default: false,
        },
    },
    setup(props: any, { emit }) {
        // hooks
        const { getTags, createTags } = useService();
        const { successToast } = useNotify();

        // reactive
        const tags = ref<Tags[]>([]);
        const newTagsName = ref('');
        const isTextArea = ref<boolean>(false);

        // methods
        const refreshTags = async () => {
            tags.value = await getTags();

            tags.value = tags.value.filter(
                (tag, index, self) =>
                    index === self.findIndex((t) => t.name === tag.name),
            );
        };

        const handleEnterPressed = async (_event: any) => {
            var formVal: any = {};
            formVal.name = _event.srcElement.value;
            let fd = new FormData();
            fd.append('json', JSON.stringify(formVal));

            try {
                await createTags(fd);
                successToast(`Geo Record Tag saved successfully.`);
            } catch (e) {
                console.log(e);
            }
            refreshTags();
        };

        const getTagName = (tagId: number) => {
            const tag = tags.value.find((tag) => tag.id === tagId);
            return tag ? tag.name : '';
        };

        const removeTag = (tagId) => {
            const filteredTagIds = props.geoRecord.tagIds.filter(
                (id) => id !== tagId,
            );
            emit('input', { ...props.geoRecord, tagIds: filteredTagIds });
        };

        const toggleTextArea = () => {
            isTextArea.value = !isTextArea.value;
        };
        // lifecycle
        onMounted(async () => {
            refreshTags();
        });

        return {
            tags,
            newTagsName,
            removeTag,
            getTagName,
            handleEnterPressed,
            isTextArea,
            toggleTextArea,
        };
    },
});
